/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Registry_DescInputs */

const en_mk_team_registry_desc = /** @type {(inputs: Mk_Team_Registry_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One agent list for every path: Claude Code, Codex, Cursor, Gemini CLI, opencode, or your own project script on your computer, each according to its capabilities. The plan and the evidence stay the same, whoever does the work.`)
};

const id_mk_team_registry_desc = /** @type {(inputs: Mk_Team_Registry_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu daftar agent untuk semua jalur: Claude Code, Codex, Cursor, Gemini CLI, opencode, atau skrip proyekmu sendiri di komputermu, sesuai kemampuan masing-masing. Rencana dan bukti tetap sama, siapa pun yang mengerjakan.`)
};

/**
* | output |
* | --- |
* | "One agent list for every path: Claude Code, Codex, Cursor, Gemini CLI, opencode, or your own project script on your computer, each according to its capabilit..." |
*
* @param {Mk_Team_Registry_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_registry_desc = /** @type {((inputs?: Mk_Team_Registry_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Registry_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_registry_desc(inputs)
	return en_mk_team_registry_desc(inputs)
});